import React, { useEffect } from 'react';
import { Modal, Input } from 'antd';
import {
  useCreateSubTemple,
  useUpdateSubTemple,
} from '../../services/sub-temple/sub-temple.service.hook';
import TmsRowVertical from '../tms-customs/tms-row-vertical';

const TmsSubTempleCreateModal = ({ templeId, isOpen, onClose, editData }) => {
  const { mutate: createSubTemple, isPending: createLoading } =
    useCreateSubTemple();
  const { mutate: updateSubTemple, isPending: updateLoading } =
    useUpdateSubTemple();

  const [shortName, setShortName] = React.useState('');
  const [name, setName] = React.useState('');

  useEffect(() => {
    if (editData) {
      setShortName(editData.shortName);
      setName(editData.name);
    }
  }, [editData]);

  useEffect(() => {
    if (!isOpen) {
      setShortName('');
      setName('');
    }
  }, [isOpen]);

  const handleCreateTemple = () => {
    if (!shortName || !name) {
      return;
    }
    if (editData) {
      updateSubTemple(
        { templeId, subTempleId: editData.id, shortName, name },
        {
          onSuccess: () => {
            onClose();
          },
        }
      );
    } else {
      console.log('comp', templeId, shortName, name);
      createSubTemple(
        {
          templeId: templeId,
          shortName: shortName,
          name: name,
        },
        {
          onSuccess: () => {
            onClose();
          },
        }
      );
    }
  };

  return (
    <Modal
      destroyOnClose={true}
      title={
        editData ? `Edit Temple Details - ${editData?.name}` : 'Create Temple'
      }
      open={isOpen}
      onOk={handleCreateTemple}
      onCancel={() => {
        onClose();
      }}
      okButtonProps={{ loading: createLoading || updateLoading }}
    >
      <TmsRowVertical
        data={{
          one: 'Short Name',
          two: (
            <Input
              maxLength={220}
              placeholder='Short Name'
              style={{ width: '250px' }}
              value={shortName}
              onChange={(e) => setShortName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreateTemple();
                }
              }}
            />
          ),
          justify: 'center',
          style: { width: '100%', padding: '10px 0px' },
        }}
      />
      <TmsRowVertical
        data={{
          one: 'Name',
          two: (
            <Input
              maxLength={220}
              placeholder='name'
              style={{ width: '250px' }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCreateTemple();
                }
              }}
            />
          ),
          justify: 'center',
          style: { width: '100%', padding: '10px 0px' },
        }}
      />
    </Modal>
  );
};

export default TmsSubTempleCreateModal;
